"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/raw-cash-balance-feed/types");
exports.artifactType = 'rawCashBalanceFeed';
exports.NodeConfigSchema = types_1.IntermediateRecordConfigSchema;
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    type: zod_1.z.literal(exports.artifactType),
    externalFilename: zod_1.z.string(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map